import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Menu } from 'types/menu';
import { getTranslation } from 'localization/helpers';
import { Meta } from 'types/meta';
import menuIcon from 'images/menuIcon.svg';
import arrowIcon from 'images/arrowIcon.svg';
import { NavigationButton } from './NavigationButtons/NavigationButton';
import { StyledLink } from 'styles/Form/StyledLink';

export const MenuBlock: FC<{ menus: Menu[]; meta: Meta }> = ({
  menus,
  meta
}) => {
  const { i18n } = useTranslation();
  const menuButtons = menus.map(menu => {
    const title = getTranslation(
      menu.translations,
      'title',
      i18n.language,
      meta.default_locale
    );
    return (
      <StyledLink to={`menu/${menu.id}`} key={menu.id}>
        <NavigationButton
          text={title || ''}
          color={meta.color}
          icon={menuIcon}
          arrow={arrowIcon}
        />
      </StyledLink>
    );
  });
  return <>{menuButtons}</>;
};
